import React from "react";

export default function RightPreviewArrow({
  size = 16,
  color = "#79808A",
}: {
  readonly size?: number;
  readonly color?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27 21L42 36L27 51"
        stroke={color}
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
